module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/city-town-selector/city-town-selector.component.html
// module id = ./src/app/modules/common-module/components/city-town-selector/city-town-selector.component.html
// module chunks = 9